export const mapPersonTypeToLabel: { [key: string]: string } = {
  applicant: "Zgłaszający",
  driver: "Kierowca",
  owner: "Właściciel pojazdu",
  other: "Inna osoba",
};

export const mapPersonTypeToLabelProperty: { [key: string]: string } = {
  ...mapPersonTypeToLabel,
  owner: "Właściciel mienia",
};
